import { CHARACTER_FIELDS, CHARACTER_FIELDS_WITH_VA } from "./fragments";

export const QUERY_CHARACTER_BY_ID = `
query ($id: Int!) {
  Character(id: $id) {
    ${CHARACTER_FIELDS}
  }
}`;

export const QUERY_CHARACTER_BY_ID_WITH_VA = `
query ($id: Int!) {
  Character(id: $id) {
    ${CHARACTER_FIELDS_WITH_VA}
  }
}`;

export function buildCharacterByIdQuery(include?: import("../types").CharacterIncludeOptions): string {
  if (!include?.customFields) {
    return include?.voiceActors ? QUERY_CHARACTER_BY_ID_WITH_VA : QUERY_CHARACTER_BY_ID;
  }
  const fields = include.voiceActors ? CHARACTER_FIELDS_WITH_VA : CHARACTER_FIELDS;
  return `query ($id: Int!) { Character(id: $id) { ${fields}\n${include.customFields} } }`;
}

export const QUERY_CHARACTER_SEARCH = `
query ($search: String, $sort: [CharacterSort], $page: Int, $perPage: Int) {
  Page(page: $page, perPage: $perPage) {
    pageInfo { total perPage currentPage lastPage hasNextPage }
    characters(search: $search, sort: $sort) {
      ${CHARACTER_FIELDS}
    }
  }
}`;

export const QUERY_CHARACTER_SEARCH_WITH_VA = `
query ($search: String, $sort: [CharacterSort], $page: Int, $perPage: Int) {
  Page(page: $page, perPage: $perPage) {
    pageInfo { total perPage currentPage lastPage hasNextPage }
    characters(search: $search, sort: $sort) {
      ${CHARACTER_FIELDS_WITH_VA}
    }
  }
}`;
